import React from "react";
import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import { Mail, MessageCircle } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#0d1b3e] text-white/80 mt-24" data-testid="site-footer">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 py-16">
        <div className="grid md:grid-cols-4 gap-10 border-b border-white/10 pb-12">
          <div className="md:col-span-2">
            <Logo mode="light" />
            <p className="serif text-3xl mt-6 text-white leading-tight max-w-md">
              Your path to France.
            </p>
            <p className="mt-4 text-sm max-w-md text-white/60 leading-relaxed">
              FrancePath is the platform Americans use to plan, apply, and move to study in France, from choosing a
              university to picking up the keys to their apartment.
            </p>
            <div className="mt-6 flex flex-col gap-2 text-sm">
              <a href="mailto:francepathfr@gmail.com" data-testid="footer-email"
                className="inline-flex items-center gap-2 hover:text-[#b8892b] transition-colors">
                <Mail size={16} /> francepathfr@gmail.com
              </a>
              <a href="https://wa.me/33618797689" target="_blank" rel="noreferrer" data-testid="footer-whatsapp"
                className="inline-flex items-center gap-2 hover:text-[#b8892b] transition-colors">
                <MessageCircle size={16} /> +33 6 18 79 76 89 · WhatsApp
              </a>
            </div>
          </div>

          <div>
            <div className="eyebrow text-[#b8892b] mb-4">The Journey</div>
            <ul className="space-y-2 text-sm">
              {[
                ["/discover", "Discover"],
                ["/plan", "Plan"],
                ["/apply", "Apply"],
                ["/prepare", "Prepare"],
                ["/thrive", "Thrive"],
              ].map(([href, label]) => (
                <li key={href}><Link to={href} className="hover:text-white text-white/60">{label}</Link></li>
              ))}
            </ul>
          </div>

          <div>
            <div className="eyebrow text-[#b8892b] mb-4">Tools</div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/advisor" className="hover:text-white text-white/60">Advisor</Link></li>
              <li><Link to="/plan" className="hover:text-white text-white/60">University search</Link></li>
              <li><Link to="/calculator" className="hover:text-white text-white/60">Cost calculator</Link></li>
              <li><Link to="/apply" className="hover:text-white text-white/60">Application tracker</Link></li>
              <li><Link to="/prepare" className="hover:text-white text-white/60">Before you move guide</Link></li>
              <li><Link to="/blog" className="hover:text-white text-white/60">Blog · Resources</Link></li>
              <li><Link to="/pricing" className="hover:text-white text-white/60">Pricing</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-8 flex flex-col md:flex-row justify-between gap-4 text-xs text-white/50">
          <div>© {new Date().getFullYear()} FrancePath. Study. Move. Thrive.</div>
          <div className="max-w-2xl">
            Educational and general in nature, not legal, tax, or financial advice. Always consult your consulate,
            university, or a licensed advisor for anything specific to your situation.
          </div>
        </div>
      </div>
    </footer>
  );
}
